'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { useTranslation } from 'react-i18next';

// UI lib components
import { Container, Stack, Center } from '@mantine/core';

// UI local components
import TextInput from '@ui-kit/molecules/TextInput';
import ConfirmBar from '@ui-kit/molecules/ConfirmBar';

// Store
import dialogStoreVar from '@features/Dialog/store/dialogStore';

// Types
import { DialogWorkspaceEditProps } from './types';

// Styles
import * as classes from './styles/index.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function DialogWorkspaceEdit({
  onConfirm,
  ...props
}: DialogWorkspaceEditProps) {
  /* ********************************** HOOKS ********************************* */

  // State
  const [workspaceName, setWorkspaceName] = useState<string>();

  // Store
  const dialogStore = useReactiveVar(dialogStoreVar);

  // Localization
  const { t } = useTranslation(['Common', 'Workspace']);

  // Style

  /* ******************************** RENDERING ******************************* */

  return (
    <Container
      className={classes.dialogWorkspaceEdit}
      onKeyDown={function cb(e) {
        switch (e.key) {
          case 'Enter':
            if (workspaceName) {
              onConfirm(workspaceName);
              dialogStore?.closeDialog?.('dialog-workspace-edit');
            }
            break;
          default:
            break;
        }
      }}
      fluid
    >
      <Stack h="100%" justify="space-between">
        <Center h="100%" w="100%">
          <TextInput
            w="25vw"
            label={t(
              'Workspace:shared.workspaceSelector.addWorkspace.dialog.inputs.name.placeholder',
            )}
            onChange={function cb(e) {
              setWorkspaceName(e.target.value);
            }}
          />
        </Center>
        <ConfirmBar
          onConfirm={() => {
            if (workspaceName) {
              onConfirm(workspaceName);
              dialogStore?.closeDialog?.('dialog-workspace-edit');
            }
          }}
          onCancel={() => {
            dialogStore?.closeDialog?.('dialog-workspace-edit');
          }}
          disabled={workspaceName === undefined || workspaceName.length === 0}
        />
      </Stack>
    </Container>
  );
}

export default DialogWorkspaceEdit;
